import * as React from 'react';
import styled from 'styled-components';
import { colors } from '../../colors/color';
import { Icon } from '../../icons/Icons';

type SaveCancelOverlayButtonRowProps = {
    show:boolean,
    saveButtonRef?: React.RefObject<HTMLButtonElement>,
    onSave:() => void,
    cancelButtonRef?: React.RefObject<HTMLButtonElement>,
    onCancel:() => void
}
export function SaveCancelOverlayButtonRow(props:SaveCancelOverlayButtonRowProps):JSX.Element
{
    return (
        <TextWithSaveButtonRow style={{ visibility: props.show ? "visible" : "hidden" }}>
        
            <TextWithSaveCancelButton
                tabIndex={1}
                ref={props.cancelButtonRef}
                onClick={props.onCancel}>
                <Icon name={"actions_close"} size={"small"} />
            </TextWithSaveCancelButton>

            <TextWithSaveSaveButton
                tabIndex={2}
                ref={props.saveButtonRef}
                onClick={props.onSave}>
                <Icon name={"actions_done"} size={"small"} />
            </TextWithSaveSaveButton>

        </TextWithSaveButtonRow>
    );
}

export const TextWithSaveButtonRow = styled.div`   
    position:absolute;
    z-index: 1000;
    display: 'block';
    margin-top: 2px;
    width: 100%;
    text-align: right;
    pointer-events: none;
    & > button {
        margin-left:5px;
        pointer-events: auto;
    }
`;


export const TextWithSaveCancelButton = styled.button`
    border: 1px solid ${colors.withSaveButton.cancel.border};
    border-radius: 4px;
    padding:2px;
    background-color: ${colors.withSaveButton.cancel.background};
    & svg {
        fill:${colors.withSaveButton.cancel.color};
    }

    &:hover{
        border-color: ${colors.withSaveButton.cancel.borderHover};
        cursor: pointer;
        & svg {
            fill:${colors.withSaveButton.cancel.colorHover};
        }
     
    }
`;

export const TextWithSaveSaveButton = styled.button`
    border: 1px solid ${colors.withSaveButton.save.border};
    border-radius: 4px;
    padding:2px;
    background-color: ${colors.withSaveButton.save.background};
    
    & svg {
        fill:${colors.withSaveButton.save.color};
    }

    &:hover{
        border-color: ${colors.withSaveButton.save.borderHover};
        cursor: pointer;
        & svg {
            fill:${colors.withSaveButton.save.colorHover};
        }
    }
`;